// initial state of form
const state = {
    changed: false
};

const mutations = {
    setFormChangeState(state, changeState) {
        state.changed = changeState;
    }
}

const getters = {
    getFormChangeState: state => state.changed,
}

const actions = {
    setFormChanged(context) {
        context.commit('setFormChangeState', true);
    },
    setFormReset(context) {
        context.commit('setFormChangeState', false);
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};
